{
  "alpha": "Alpha",
  "alphaFeedback": "Commentaires sur la version alpha",
  "beta": "Bêta",
  "betaFeedback": "Commentaires sur la version bêta"
}
